import { type FC } from 'react'
import { Grid, Box, type Theme, Typography, CardContent, Divider, type SxProps } from '@mui/material'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'

import { LockerOpen, ServicePoint } from '@dhl/illustrations'
import { SelectableCard } from '@dhl/components'

export type InputKind = 'Servicepoint' | 'PackStation'

const styles: Record<string, SxProps<Theme>> = {
  illustration: {
    height: '67px',
    width: '100px',
  },
  cardContent: {
    textAlign: 'center',
    padding: (theme) => theme.spacing(2),
  },
}

type Props = {
  name: string
}

export const ServicepointInputKindInput: FC<Props> = ({ name }) => {
  const { t } = useTranslation()
  const [field] = useField<InputKind>(name)

  return (
    <Grid container wrap="nowrap" spacing={1} direction="row" alignItems="stretch">
      <Grid size={6}>
        <SelectableCard
          onClick={() => field.onChange(field.name)('PackStation')}
          isSelected={field.value === 'PackStation'}
        >
          <CardContent sx={styles.cardContent}>
            <Box mb={2}>
              <Typography variant="h5">{t('components.servicePointInput.yesText')}</Typography>
            </Box>
            <Divider />
            <Box mt={1}>
              <LockerOpen sx={styles.illustration} />
            </Box>
          </CardContent>
        </SelectableCard>
      </Grid>
      <Grid size={6}>
        <SelectableCard
          onClick={() => field.onChange(field.name)('Servicepoint')}
          isSelected={field.value === 'Servicepoint'}
        >
          <CardContent sx={styles.cardContent}>
            <Box mb={2}>
              <Typography variant="h5">{t('components.servicePointInput.noText')}</Typography>
            </Box>
            <Divider />
            <Box mt={1}>
              <ServicePoint sx={styles.illustration} />
            </Box>
          </CardContent>
        </SelectableCard>
      </Grid>
    </Grid>
  )
}
